export const paths = {
	index: "/",
	login: "/login",
	monitor: "/computer",
};
